export const languages = {
  js: 'javascript',
  jsx: 'javascript',
  rb: 'ruby',
  ru: 'ruby',
  md: 'markdown',
  py: 'python',
  yml: 'yaml'
};

export const fileIcons = {
  css: 'fab fa-css3',
  scss: 'fab fa-sass',
  html: 'fas fa-code',
  js: 'fab fa-js',
  json: 'far fa-file-alt',
  file: 'far fa-file-alt',
  dir: 'fas fa-folder',
  largeFile: 'far fa-file-excel',
  svg: 'far fa-file-image',
  jpeg: 'far fa-file-image',
  jpg: 'far fa-file-image',
  png: 'far fa-file-image',
  pdf: 'far fa-file-pdf',
  doc: 'far fa-file-word',
  docx: 'far fa-file-word',
  ppt: 'far fa-file-powerpoint',
  pptx: 'far fa-file-powerpoint',
  mp4: 'far fa-file-video',
  mkv: 'far fa-file-video',
  mov: 'far fa-file-video',
  mpg: 'far fa-file-video',
  flv: 'far fa-file-video',
  wmv: 'far fa-file-video',
  csv: 'far fa-file-alt',
  zip: 'far fa-file-archive',
  tar: 'far fa-file-archive',
  mp3: 'far fa-file-audio',
  m4a: 'far fa-file-audio',
  m3u: 'far fa-file-audio',
  aac: 'far fa-file-audio',
  wma: 'far fa-file-audio',
  aiff: 'far fa-file-audio'
};

export const previewIcons = {
  css: 'fab fa-css3',
  scss: 'fab fa-sass',
  html: 'fas fa-code',
  js: 'fab fa-js',
  json: 'far fa-file-alt',
  file: 'far fa-file-alt',
  largeFile: 'far fa-file-excel',
  pdf: 'far fa-file-pdf',
  doc: 'far fa-file-word',
  docx: 'far fa-file-word',
  ppt: 'far fa-file-powerpoint',
  pptx: 'far fa-file-powerpoint',
  mp4: 'far fa-file-video',
  mkv: 'far fa-file-video',
  mov: 'far fa-file-video',
  mpg: 'far fa-file-video',
  flv: 'far fa-file-video',
  wmv: 'far fa-file-video',
  csv: 'far fa-file-alt',
  zip: 'far fa-file-archive',
  tar: 'far fa-file-archive',
  mp3: 'far fa-file-audio',
  m4a: 'far fa-file-audio',
  m3u: 'far fa-file-audio',
  aac: 'far fa-file-audio',
  wma: 'far fa-file-audio',
  aiff: 'far fa-file-audio'
};

export const errorMessages = {
  largeFile: '* Preview unavailable - image is over 1MB.',
  pdf: 'Cannot preview PDF.'
};

export const imageExtensions = ['jpg', 'jpeg', 'svg', 'png', 'gif', 'ico'];
